// @ts-nocheck
import { GetProductByPathApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { chain } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import setCuttingInstructions from "@store/Framework/Store/Store/Data/CuttingInstructions/Handlers/SetCuttingInstructions";
import {
    addToEndOfChain,
    executeAwaitableHandlerChain,
    Handler,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = {
    path: string;
    addToRecentlyViewed?: boolean;
} & HasOnSuccess<ProductModel> &
    HasOnError<string>;
type Props = {
    apiParameter: GetProductByPathApiV2Parameter;
    apiResult: ProductModel;
};

type HandlerType = Handler<Parameter, Props>;

export const GetCuttableVariantChilds: HandlerType = async props => {
    if (
        props.apiResult.isVariantParent &&
        props.apiResult.properties["isCuttableVariants"] &&
        props.apiResult.properties["isCuttableVariants"] !== ""
    ) {
        await executeAwaitableHandlerChain(
            setCuttingInstructions,
            { isCuttableVariants: props.apiResult.properties["isCuttableVariants"] },
            props,
        );
    }
};

addToEndOfChain(chain, GetCuttableVariantChilds);
